<template>
  <section class="task-wrap">
  <div class="modal-window">
    <header class="modal-header">
      <div class="tit" >{{$i18nUtil.trans("message.RoleUserSetting.001","사용자 등록")}}</div>
      <button @click="$emit('close')" class="btn_close">{{$i18nUtil.trans("button.close","닫기")}}</button>
    </header>
    <div class="modal-content" >
        <div class="krs019">
          <ul>
            <li>
              <dl class="clear">
                <dt>{{$i18nUtil.trans("entity.user.deptName.002","부서명")}}</dt>
                <dd>
                  <div class="txt">
                    <input 
                          type="text" 
                          v-model="modalInfo.deptName"
                          style="background-color: white; color: black;width: 65%;"
                          disabled
                    />              
                  </div>
                </dd>
              </dl>
            </li>
            <li>
              <dl class="clear">
                <dt>{{$i18nUtil.trans("entity.user.user")}}</dt>
                <dd>
                  <div class="txt">
                    <input
                          type="text"
                          v-model="addUserNameList"
                          :placeholder="$i18nUtil.trans('message.RoleUserRegist.003','사용자를 선택해 주세요.')"
                          style="background-color: white; color: black;width: 65%;"
                          disabled
                    />
                  </div>
                  <button
                        type="button"
                        class="btn-primary-small"
                        @click="addUser"
                  >{{$i18nUtil.trans("message.RoleUserRegist.002","사용자 추가")}}
                  </button>
                </dd>
              </dl>
            </li>
            <li>
              <dl class="clear">
                <dt>{{$i18nUtil.trans("message.TodoDeptUserRegist.001","타입")}}</dt>
                <dd>
                  <div class="txt">
                    <input type="radio" name="InUser" id="InUser" value="INCLUDE" v-model="userType"><label for="InUser">INCLUDE</label>
                    <!-- <input type="radio" name="ExUser" id="ExUser" value="EXCLUDE" v-model="userType"><label for="ExUser">EXCLUDE</label> -->
                  </div>
                </dd>
              </dl>
            </li>
              <button
                      type="button"
                      class="btn-primary-small black"
                      @click="saveUserInfo"
                      style="float: right; margin-top: 10px;"
              >{{$i18nUtil.trans("button.save","저장")}}
              </button>
          </ul>
        </div>
    </div>
  </div>
  </section>
</template>

<script>
import { mapActions } from "vuex";
import MultiOrg from "@/components/cowork/common/organization/org/MultiOrg";

export default {
  props: {
    modalInfo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000,
        },
      },
      deptName : '',
      deptId : '',
      userName : '',
      userId : '',
      userType : 'DEFAULT',
      checkUsers : [],
      addUserNameList : [],
      addUserIdList : [],
    };
  },
  created(){
      /* 조직도에서 사용자 추가 시 */
      EventBus.$off("returnDeptUser");
      EventBus.$on("returnDeptUser", param => {
        let obj = this;
        obj.returnUser(param);
      });
    },
  methods: {
    ...mapActions("modals", ["showToast", "showModal"]),
    /* rest Call&CallBack Action */
    ...mapActions("restAction", ["COWORK_REST_ACTION"]),
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    /* 사용자 추가 클릭 시 */
    addUser() {
      let modalInfo = {};
        modalInfo = {
          title: "조직도",
          method: "post",
          width: "1050px",
          height: "860px",
          obj: this.$modal,          
          orgType: "MULTI_ORG",          
          component: MultiOrg,
          url: "/api/org/getDeptList",
          mode: "ORG_PAPER_DEPT_USER",
        };      
      this.showModal(modalInfo);
    },
    /* 저장 버튼 클릭 시 */
    saveUserInfo() {
      let obj = this;
      if(obj.addUserNameList.length < 1){
        obj.toastInfo.message = obj.$i18nUtil.trans("message.RoleUserRegist.003","사용자를 선택해 주세요.");
        obj.showToast(obj.toastInfo);
      } else if(obj.userType == 'DEFAULT') {
        obj.toastInfo.message = obj.$i18nUtil.trans("message.TodoDeptUserRegist.002","타입을 선택해 주세요.");
        obj.showToast(obj.toastInfo);
      }
      else if(confirm(obj.$i18nUtil.trans("message.TodoDeptUserRegist.003","{deptName} 부서에 사용자를 추가하여 저장하시겠습니까?",{deptName:obj.deptName}))) {
        let reqData = {    
          url : "/api/copaper/todo/saveTodoDeptUserList",
          method : "post",
          params : {
            saveUserId : obj.addUserIdList,
            userType : obj.userType,
            deptId : this.modalInfo.deptId,
          }
        };
        obj.COWORK_REST_SIMPLE_ACTION(reqData)
          .then(function (res) {
            if(res.errorCode !== null) {
              console.log(res.errorCode);
            } else {
              if(res.result.length > 0){ // 중복 사용자가 존재하면 0이상
              let duplUser = [];              
              res.result.forEach(element => {
                duplUser.push(element);
              });
              // addUserNameList(조직도에서 선택한 사용자)와 duplUser(이미 존재하는 사용자)의 length가 다르면, 중복되지 않은 사용자는 insert 되었으므로 emit 호출.
              if(obj.addUserNameList.length != duplUser.length){
                obj.toastInfo.message = obj.$i18nUtil.trans("message.RoleUserRegist.005","{user}은(는) 이미 존재하는 사용자입니다.",{user:duplUser})+" "+obj.$i18nUtil.trans("message.RoleUserRegist.006","{user}을(를) 제외한 사용자가 등록되었습니다.",{user:duplUser});
                obj.showToast(obj.toastInfo);
                obj.$emit('afterAdd');
                setTimeout(function(){
                  obj.$emit('close');
                },500);
              }else{
                obj.toastInfo.message = obj.$i18nUtil.trans("message.RoleUserRegist.005","{user}은(는) 이미 존재하는 사용자입니다.",{user:duplUser});
                obj.showToast(obj.toastInfo);
              }
            } else {
                obj.toastInfo.message = obj.$i18nUtil.trans("message.TodoDeptUserRegist.004","저장 되었습니다.");
                obj.showToast(obj.toastInfo);
                obj.$emit('afterAdd');
                setTimeout(function(){
                  obj.$emit('close');
                },500);
              }
            }
          })
          .catch(function (err) {
            console.log(err);
        });
      }
    },
    returnUser(param){
      let obj = this;
      let users = param.users;
      if (users.length > 0) {
        obj.addUserNameList = [];
        obj.addUserIdList = [];
        for(var i=0; i<users.length; i++) {
          let userName = users[i].userName;
          let userId = users[i].userId;
          obj.addUserNameList.push(userName);
          obj.addUserIdList.push(userId);
        }
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/cosys/audit/base/tab/history/modal/TodoDeptUserRegist.vue